import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { MemberListContainer } from "../../containers";
import { mapGetters } from "vuex";
import api from "@orgmap/api";
import * as accountTypes from "@account/store/types";

@Component({
    name: "HrUserListView",
    components: { MemberListContainer },
    computed: {
        ...mapGetters({
            user: accountTypes.USER,
        }),
    },
})
export default class HrUserListView extends Vue {
    //
    // ────────────────────────────────────────────────── I ──────────
    //   :::::: P R O P S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────
    //

    @Prop({ type: Object, default: null }) dept!: orgmap.TDepartmentTreeItem;
    @Prop({ type: String }) userlang!: string;

    //
    // ──────────────────────────────────────────────── I ──────────
    //   :::::: D A T A : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────
    //

    user!: account.User;

    deptCode: string = "";
    comCode: string = "";
    deptName: string = "";
    companyName: string = "";
    parentDeptCode: string = "";

    //
    // ────────────────────────────────────────────────── I ──────────
    //   :::::: W A T C H : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────
    //

    @Watch("dept")
    onCurrentDeptChanged(newValue: orgmap.TDepartmentTreeItem, oldValue: orgmap.TDepartmentTreeItem) {
        if (newValue) {
            this.deptCode = newValue.deptCode;
            this.comCode = newValue.comCode;
            this.deptName = this.getLangProperty(newValue, "deptName");
            this.parentDeptCode = newValue.parentDeptCode;
        } else {
            this.deptCode = "";
            this.comCode = "";
            this.deptName = "";
            this.parentDeptCode = "";
        }
    }

    @Watch("comCode")
    onCurrentComCodeChanged(comCode: string) {
        api.hr.getCompanies().then((res: orgmap.Company[]) => {
            var company = res.find((x) => x.comCode == comCode);
            if (company) this.companyName = this.getLangProperty(company, "companyName");
        });
    }

    created() {
        this.comCode = this.user.comCode;
    }
}
